import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ParentLocationLookupComponent } from './parent-location-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ParentLocationLookupComponent],
  exports: [ParentLocationLookupComponent],
  providers: []
})
export class ParentLocationLookupModule { }
